type InventoryType = {
  [key: string]: string;
};

const inventoryTypes: InventoryType = {
  RESORT_PASS: 'resortpass',
};

export default inventoryTypes;
